import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';
import { submitComment } from '../../redux/actions/dataActions';

// MUI stuff
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

class CommentForm extends Component {

    state = {
        body: '',
        errors: {}
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.UI.errors) {
            this.setState({ errors: nextProps.UI.errors })
        }
        if (!nextProps.UI.errors && !nextProps.UI.loading) {
            this.setState({ body: '' });
        }
    }

    handleChange = event => this.setState({ [event.target.name]: event.target.value });

    handleSubmit = event => {
        event.preventDefault();
        this.props.submitComment(this.props.screamId, { body: this.state.body });
    }

    render() {
        const { authenticated } = this.props;
        const errors = this.state.errors;

        const commentFormMarkup = authenticated
            ? (
                <Stack spacing={2} sx={{ width: '100%', px: 4, pt:2 }}>
                    <form onSubmit={this.handleSubmit}>
                        <Stack spacing={2}>
                            <TextField
                                name="body"
                                type="text"
                                label="Comment on scream"
                                error={errors.comment ? true : false}
                                helperText={errors.comment}
                                onChange={this.handleChange}
                                fullWidth
                                value={this.state.body}
                            />
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                sx={{ alignSelf: 'flex-end', minWidth: 120 }}>
                                Comment
                            </Button>
                        </Stack>
                    </form>
                </Stack>
            ) : null

        return commentFormMarkup;
    }
}

CommentForm.propTypes = {
    submitComment: PropTypes.func.isRequired,
    UI: PropTypes.object.isRequired,
    screamId: PropTypes.string.isRequired,
    authenticated: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
    UI: state.UI,
    authenticated: state.user.authenticated
});

export default connect(mapStateToProps, { submitComment })(CommentForm);
